/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* =============================================================
   3BUTE — Productnaam altijd op 1 regel
   Verkleint het font van de producttitel (h1.product-meta__title)
   net zo lang tot de volledige naam op 1 regel past, ongeacht de
   lengte. Werkt samen met de basis font-size uit custom.css.
   ============================================================= */
(function () {
  function initProductTitleFit() {
    var el = document.querySelector('.product-meta__title');
    if (!el) return;

    // Capture the CSS-defined size once, before any inline override,
    // so repeated fits (e.g. on resize) always start from the same
    // baseline instead of shrinking a little further every time.
    var baseFontSize = parseFloat(getComputedStyle(el).fontSize);
    var minFontSize = 14;

    function fit() {
      el.style.whiteSpace = 'nowrap';
      el.style.overflow = 'hidden';

      var fontSize = baseFontSize;
      el.style.fontSize = fontSize + 'px';

      var attempts = 0;
      while (el.scrollWidth > el.clientWidth && fontSize > minFontSize && attempts < 40) {
        fontSize -= 1;
        el.style.fontSize = fontSize + 'px';
        attempts++;
      }
    }

    fit();
    window.addEventListener('load', fit);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fit, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTitleFit);
  } else {
    initProductTitleFit();
  }
})();


/* =============================================================
   3BUTE — "Toevoegen aan winkelwagen" naast de Aantal-stepper
   De knop leeft normaal in .product-form__buy-buttons, een apart
   blok, los van de Aantal-stepper (.product-form__quantity-with-
   rules). Om 'm er toch naast te tonen, plaatsen we een KLOON van
   de knop in de stepper-wrapper — het origineel blijft altijd
   veilig op zijn eigen plek staan en wordt alleen via CSS verborgen
   (.bute-payment-original--hidden, zie custom.css).

   Waarom een kloon i.p.v. het origineel verplaatsen: op producten
   met native Shopify-varianten (bv. Dimout met een "Rol lengte"-
   optie) vervangt Shopify bij het wisselen van variant de hele
   .product-form__info-list via AJAX. Was het origineel daarheen
   verplaatst, dan verdween de knop bij zo'n update definitief van
   de hele pagina.

   Waarom een MutationObserver i.p.v. de 'variant:changed'/
   'shopify:section:load' events (een eerdere versie deed dat):
   'variant:changed' bleek hier te vroeg te vuren — vóórdat de
   AJAX-vervanging van .product-form__info-list daadwerkelijk in de
   DOM staat — waardoor de net-geplaatste kloon meteen weer werd
   weggegooid toen de echte DOM-vervanging alsnog volgde. Een
   MutationObserver op <product-form> reageert op de daadwerkelijke
   DOM-wijziging zelf, ongeacht welk event (als überhaupt) de theme
   daarbij vuurt, en is dus niet afhankelijk van de exacte timing.
   De guard bovenin syncBuyButtonNextToQuantity (die stopt zodra er
   al een kloon staat) voorkomt dat de observer zichzelf oneindig
   laat afvuren op zijn eigen wijziging.

   De "Toevoegen aan Mijn Favorieten"-knop (.nm-portal, wishlist-
   app) zit in hetzelfde .product-form__buy-buttons blok maar wordt
   bewust niet aangeraakt, en blijft dus gewoon onder de
   staffeltabel staan.
   ============================================================= */
(function () {
  function syncBuyButtonNextToQuantity() {
    var quantityWrapper = document.querySelector('.product-form__quantity-with-rules');
    var original = document.querySelector('.product-form__buy-buttons .product-form__payment-container');
    if (!quantityWrapper || !original) return;

    if (quantityWrapper.querySelector('.bute-payment-clone')) return;

    var staleClone = document.querySelector('.bute-payment-clone');
    if (staleClone) staleClone.remove();

    var clone = original.cloneNode(true);
    clone.classList.add('bute-payment-clone');
    clone.querySelectorAll('[bss-b2b-cart-trigger-added]').forEach(function (el) {
      el.removeAttribute('bss-b2b-cart-trigger-added');
    });
    quantityWrapper.appendChild(clone);

    original.classList.add('bute-payment-original--hidden');
  }

  function init() {
    syncBuyButtonNextToQuantity();

    var observeRoot = document.querySelector('product-form') || document.body;
    var observer = new MutationObserver(syncBuyButtonNextToQuantity);
    observer.observe(observeRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
